import { createInitialConnectionsState } from 'src/store/connections/types';
import {
  Project,
  ProjectModel,
  ProjectVirtualGraph,
  ProjectsState,
} from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * * on {@link ProjectModel} and {@link ProjectVirtualGraph}: remove `connectionName` and set `connectionId` to null
 * * on {@link ReduxState}: reset `connections` to default
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v3 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.connections) {
    nextState.connections = createInitialConnectionsState();
  }

  if (nextState.projects) {
    nextState.projects = v3Projects(prevState.projects);
  }

  return nextState;
};

const v3Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    type OldProjectModel = Omit<ProjectModel, 'connectionId'> & {
      connectionName: string;
    };
    type OldProjectVirtualGraph = Omit<ProjectVirtualGraph, 'connectionId'> & {
      connectionName: string;
    };
    const modelsById: Record<string, ProjectModel> = {};
    const virtualGraphsById: Record<string, ProjectVirtualGraph> = {};

    Object.entries(
      project.modelsById as unknown as Record<string, OldProjectModel>
    ).forEach(([id, { connectionName: _, ...model }]) => {
      modelsById[id] = {
        ...model,
        connectionId: null,
      };
    });

    Object.entries(
      project.virtualGraphsById as unknown as Record<
        string,
        OldProjectVirtualGraph
      >
    ).forEach(([id, { connectionName: _, ...virtualGraph }]) => {
      virtualGraphsById[id] = {
        ...virtualGraph,
        connectionId: null,
      };
    });

    projectsById[projectId] = {
      ...project,
      modelsById,
      virtualGraphsById,
    };
  });

  return { ...prevProjectsState, projectsById };
};
